import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as m } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const h = m((l, c) => /* @__PURE__ */ o.jsx(
  r,
  {
    ref: c,
    ...l,
    image: (s) => /* @__PURE__ */ o.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 194,
        height: 64,
        fill: "none",
        viewBox: "0 0 194 64",
        ...s,
        children: [
          /* @__PURE__ */ o.jsx("path", { fill: "currentColor", d: "M.075 0H193.53v64H.075z" }),
          /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "#F6F5E9",
              fillRule: "evenodd",
              d: "M27.122 37.339c3.246 0 6.098-1.571 7.603-3.7h.004l3.852 3.383c-2.476 3.38-6.452 5.895-11.459 5.895-8.202 0-15.41-5.913-15.41-15.257s7.457-15.296 15.326-15.296c5.032 0 8.943 2.355 11.455 5.99l-4.14 3.634c-1.633-2.505-3.9-4.123-7.311-4.123-4.393 0-9.407 3.142-9.407 9.799 0 6.244 4.765 9.675 9.487 9.675m83.316-24.975h-5.51v29.933h5.51zM78.12 27.414a8.3 8.3 0 0 0-1.657-.165c-2.816 0-5.259 1.364-5.259 5.745v9.304h-5.51V21.956h4.444l.628 3.277c1.14-2.694 4.327-3.441 6.069-3.441.457 0 .87.04 1.285.084zm12.872 10.5c-2.692 0-5.365-1.983-5.365-5.788s2.673-5.79 5.365-5.79c2.69 0 5.364 1.944 5.364 5.79s-2.673 5.788-5.364 5.788m0-16.58c-6.088 0-10.872 4.507-10.872 10.792 0 6.284 4.784 10.79 10.872 10.79 6.087 0 10.874-4.55 10.874-10.79 0-6.242-4.783-10.791-10.874-10.791m28.3 10.792c0 3.805 2.673 5.788 5.364 5.788s5.364-1.943 5.364-5.788-2.673-5.79-5.364-5.79-5.364 1.984-5.364 5.79m-5.507 0c0-6.285 4.784-10.791 10.871-10.791 6.091 0 10.875 4.55 10.875 10.79 0 6.242-4.788 10.791-10.875 10.791s-10.871-4.506-10.871-10.79m-58.81 7.98c-1.117 1.903-3.48 2.73-5.63 2.73-4.93 0-7.745-3.598-7.745-8.02v-12.86h5.506v11.741c0 2.275 1.162 4.094 3.729 4.094s3.852-1.655 3.852-4.01V21.955h5.507v20.342h-4.816zm102.072-10.332c0 2.603-1.358 4.794-3.261 6.285h-.007c2.067 1.633 3.593 3.974 3.593 6.967 0 4.99-4.009 8.614-9.312 8.614-3.666 0-6.847-1.87-8.304-4.885l-.117-.244 4.393-2.144.114.259c.796 1.845 2.647 2.497 3.991 2.497 2.377 0 4.382-1.87 4.382-4.258 0-2.625-1.884-4.455-4.382-4.455-1.698 0-3.25.937-3.955 2.388l-.117.244-4.287-2.1.124-.244c.559-1.108 1.457-1.98 2.454-2.632-1.763-1.214-3.224-3.674-3.224-6.288 0-5.027 3.885-8.44 8.958-8.44 1.34 0 2.607.263 3.746.752l2.735-2.73 3.02 3.014-2.348 2.344c1.132 1.48 1.804 2.873 1.804 5.056m-4.981.062c0-2.34-1.691-4.013-3.991-4.013-2.242 0-3.977 1.698-3.977 4.013s1.654 4.018 3.977 4.018 3.991-1.677 3.991-4.018m16.506 9.37-8.401-17.25h6.171l5.182 11.372 5.255-11.373h5.883l-14.538 29.412h-5.839l5.883-11.363z",
              clipRule: "evenodd"
            }
          )
        ]
      }
    )
  }
));
h.displayName = "CurologyLogoWordmarkIcon";
export {
  h as CurologyLogoWordmarkIcon,
  h as default
};
//# sourceMappingURL=index.js.map
